export const ghi_quotes = [
  {
    id: 1,
    ghi_si: "2L",
    e: 3000,
    esc: 5000,
    escp: 19000
  },
  {
    id: 2,
    ghi_si: "3L",
    e: 3500,
    esc: 6400,
    escp: 25000
  },
  {
    id: 3,
    ghi_si: "5L",
    e: 4500,
    esc: 9000,
    escp: 36000
  },
  {
    id: 4,
    ghi_si: "10L",
    e: 5500,
    esc: 16000,
    escp: 0
  }
];

export const ghi_quotes_under_25 = [
  {
    id: 1,
    ghi_si: "2L",
    e: 4504,
    esc: 8879,
    escp: 0
  },
  {
    id: 2,
    ghi_si: "3L",
    e: 5283,
    esc: 10741,
    escp: 0
  },
  {
    id: 3,
    ghi_si: "5L",
    e: 6736,
    esc: 14225,
    escp: 0
  },
  {
    id: 4,
    ghi_si: "10L",
    e: 0,
    esc: 0,
    escp: 0
  }
];

export const gpa_quotes = [
  {
    id: 1,
    gpa_si: "5L",
    premium: 200
  },
  {
    id: 2,
    gpa_si: "10L",
    premium: 400
  },
  {
    id: 3,
    gpa_si: "20L",
    premium: 800
  },
  {
    id: 4,
    gpa_si: "50L",
    premium: 2000
  },
]

export const gtli_quotes = [
  {
    id: 1,
    gtli_si: "5L",
    premium: 625
  },
  {
    id: 2,
    gtli_si: "10L",
    premium: 1250
  },
  {
    id: 3,
    gtli_si: "20L",
    premium: 2500
  },
  {
    id: 4,
    gtli_si: "30L",
    premium: 3750
  },
]

export const hnw_quotes = {
  doctor_teleconsultation: [
    {
      id: 1,
      premium: 249,
      plan: "gp"
    },
    {
      id: 2,
      premium: 599,
      plan: "gp10"
    },
    {
      id: 3,
      premium: 799,
      plan: "gp16"
    }
  ],
  health_checkups: [
    {
      id: 4,
      premium: 299,
      plan: "lite"
    },
    {
      id: 1,
      premium: 399,
      plan: "basic"
    },
    {
      id: 2,
      premium: 499,
      plan: "advanced"
    },
    {
      id: 3,
      premium: 699,
      plan: "comprehensive"
    }
  ],
  gym_membership: [
    {
      id: 1,
      premium: 6999,
      plan: "elite"
    },
    {
      id: 2,
      premium: 777,
      plan: "home"
    },
  ],
  emotional_wellness: [
    {
      id: 1,
      premium: 599,
      plan: "5sessions"
    },
    {
      id: 2,
      premium: 1999,
      plan: "unlimited"
    },
  ],
  dental_cover: [
    {
      id: 1,
      premium: 299,
      plan: "3k"
    },
    {
      id: 2,
      premium: 499,
      plan: "5k"
    }
  ],
};

export const base_city_discount = [
  {
    id: 1,
    tier: "tier1",
    discount: 0
  },
  {
    id: 2,
    tier: "tier2",
    discount: 0.1
  },
  {
    id: 3,
    tier: "tier3",
    discount: 0.2
  },
]

export const without_maternity = {
  e: -800,
  esc: -1600,
  escp: -2000,
};


export const without_maternity_under_25 = [
  {
    id: 1,
    ghi_si: "2L",
    e: -1729,
    esc: -1978,
    escp: 0
  },
  {
    id: 2,
    ghi_si: "3L",
    e: -1723,
    esc: -1904,
    escp: 0
  },
  {
    id: 3,
    ghi_si: "5L",
    e: -1712,
    esc: -1767,
    escp: 0
  },
  {
    id: 4,
    ghi_si: "10L",
    e: 0,
    esc: 0,
    escp: 0
  }
];

export const base_type_discount = [
  {
    id: 1,
    plan_type: "silver",
    discount: 0.1
  },
  {
    id: 2,
    plan_type: "gold",
    discount: 0.05
  },
  {
    id: 3,
    plan_type: "platinum",
    discount: 0
  },
];

export const city_tier_relationship = [
  {
    cities: ["delhi", "mumbai", "bangalore", "hyderabad"],
    tier: "tier1"
  },
  {
    cities: ["ahmedabad",  "chennai", "kolkata", "pune", "secunderabad", "surat", "vadodara"],
    tier: "tier2"
  },
  {
    cities: ["rest_of_india"],
    tier: "tier3"
  },
]

export const costs = {
  buffer: 0.05,
  inflation: 0.05,
  management: 0.15,
}

export const ibnr_percentage = 0.04;

export const opd_quotes = [
  {
    id: 1,
    opd_si: '3000',
    premium: 999,
  },
  {
    id: 2,
    opd_si: '15000',
    premium: 2999,
  },
  {
    id: 3,
    opd_si: '30000',
    premium: 7999,
  },
];
